// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__VSq9i","content":"styles_content__2jGme","checkbox":"styles_checkbox__2TRGX","checkboxLabel":"styles_checkboxLabel__1ZKZE"};